module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "老师课程请假"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "dataForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "请假类型："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.formData.leaveType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveType", $$v)
      },
      expression: "formData.leaveType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("常规请假Standard leave")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("临时请假 Emergency leave")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("老师失联NCNS")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("取消课Cancellation")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "height": "50px",
      "width": "400px"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "margin": "0px 20px"
    }
  }, [_vm._v("请假课程：" + _vm._s(_vm.formData.beginTime))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formData.title))])])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假原因：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.onTchLeave
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0a12fb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchLessonLeaveModal.vue
// module id = 1919
// module chunks = 8